import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Advertorial } from './pages/Advertorial';
import { ProductPage } from './pages/ProductPage';
import { Checkout } from './pages/Checkout';
import { useFacebookPixel } from './hooks/useFacebookPixel';
// Create a component to track route changes
const RouteChangeTracker = () => {
  const location = useLocation();
  const {
    trackEvent
  } = useFacebookPixel();
  useEffect(() => {
    if (window.fbq) {
      trackEvent('PageView');
    }
  }, [location, trackEvent]);
  return null;
};
// Wrapper component to use hooks with BrowserRouter
const AppRoutes = () => {
  return <>
      <RouteChangeTracker data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<Advertorial data-id="element-5" />} data-id="element-4" />
        <Route path="/adv" element={<Advertorial data-id="element-7" />} data-id="element-6" />
        <Route path="/pdp" element={<ProductPage data-id="element-9" />} data-id="element-8" />
        <Route path="/checkout" element={<Checkout data-id="element-11" />} data-id="element-10" />
      </Routes>
    </>;
};
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <AppRoutes data-id="element-13" />
    </BrowserRouter>;
}